import { useLayoutEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

if (process.env.NODE_ENV !== 'production') {
  window.__ST = ScrollTrigger;
  window.__gsap = gsap;
}

export { gsap, ScrollTrigger };

/* Hareket kapalıysa sahne son halinde durur, sürücü hiç kurulmaz. */
export const prefersReduced = () =>
  typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/* Bir akt kurar. setup(root) içinde gsap.timeline yazılır,
   gsap.context temizliği kendi yapar. */
export function useAct(setup, deps = []) {
  const ref = useRef(null);

  useLayoutEffect(() => {
    const root = ref.current;
    if (!root) return undefined;

    const ctx = gsap.context(() => setup(root), root);

    /* Yeni kurulan tetikleyici ilk küresel yenilemeyi almıyor, bu yüzden
       pin mesafesi sıfır kalıyor. Her birini tek tek yeniliyoruz. */
    const raf = requestAnimationFrame(() => {
      ScrollTrigger.getAll().forEach((t) => t.refresh());
      ScrollTrigger.refresh();
    });

    return () => {
      cancelAnimationFrame(raf);
      ctx.revert();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return ref;
}

/* ?debug=true ile ScrollTrigger işaretleri açılır. */
export const DEBUG =
  typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('debug') === 'true';
